import request from '@/utils/request/index'

export default {
  login(data) {
    return request.post(
      '/v1/lab/login',
      data
    )
  }
}
